// @flow
export { default } from './VerticalLayout';



// WEBPACK FOOTER //
// ../react-lib/src/components/layouts/VerticalLayout/index.js